import React from "react";
import { useState, useEffect } from "react";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useDispatch, useSelector } from "react-redux";
import { HttpJsonHeader } from "../../../features/Environments";
import { Button, Badge, OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import { AiFillEdit, AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";

import StaffPopup from "./StaffPopup";
import ModalDialog from "../../components/ModalDialog";
import { SerachBox } from "../../components/SerachBox";
import { PageOptions } from "../../components/PageParams";
import ImageCapture from "./ImageCapture";
import { setReminder } from "../../../features/UserActions";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { GetHeaderStyle } from "../../../core/Helper";
import { MyModalDialog } from "../../../features/RadConnStyle";

export default function Staff() {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.user.detail);
  const [data, setData] = useState([]);
  const [fields, setFields] = useState(null);
  const [popupVisible, setPopupVisible] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(true);
  const [confirmBox, setConfirmBox] = useState({
    showConfirm: false,
    confirm: false,
    data: null,
  });
  const [capture, setCapture] = useState(false);
  const [staffImage, setStaffImage] = useState(
    process.env.REACT_APP_PHOTO + "anonymous.png"
  );

  //----------------------------------------------------------------------
  const props = {
    formName: "เจ้าหน้าที่",
    filedIdName: "staffid",
    showEdit: popupVisible,
    fields: fields,
    hidePopup: () => {
      setPopupVisible(false);
    },
    setUpdate: setUpdateFlag,
    user: userDetail,
  };
  //----------------------------------------------------------------------
  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);
  //----------------------------------------------------------------------
  const getData = () => {
    axios
      .post(process.env.REACT_APP_API + "api/staff/select", {}, HttpJsonHeader)
      .then((response) => {
        setData(response.data.lists);
      })
      .catch((err) => alert(err));
  };
  //----------------------------------------------------------------------
  // Add New
  const popupNew = () => {
    setFields(null);
    setPopupVisible(true);
    setStaffImage(process.env.REACT_APP_PHOTO + "anonymous.png");
  };
  //----------------------------------------------------------------------
  // Edit Data
  const popupEditData = (row) => {
    if (row && row.image_name) {
      setStaffImage(process.env.REACT_APP_PHOTO + row.image_name);
    } else {
      setStaffImage(process.env.REACT_APP_PHOTO + "anonymous.png");
    }
    setFields(row);
    setPopupVisible(true);
  };
  //----------------------------------------------------------------------
  // Delete Data
  const popupDelete = (row) => {
    setConfirmBox({ showConfirm: true, confirm: false, data: row });
  };
  //----------------------------------------------------------------------
  const deleteRow = (data) => {
    axios
      .post(
        process.env.REACT_APP_API + "api/staff/delete",
        { StaffId: data.staffid, UpdateBy: userDetail.userid },
        HttpJsonHeader
      )
      .then((res) => {
        setUpdateFlag(true);
        dispatch(
          setReminder({ show: true, message: "ยกเลิกสมบูรณ์", type: "success" })
        );
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" })
        )
      );
  };

  //----------------------------------------------------------------------
  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => popupEditData(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              popupDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };
  //----------------------------------------------------------------------
  const commonNonBorder = () => {
    return { border: "none", color: "var(--table-text-color)" };
  };

  const customTextFilter = {
    placeholder: "...",
  };

  const columns = [
    {
      dataField: "staffcode",
      text: "รหัส",
      sort: true,
      style: commonNonBorder,
      headerStyle: () => GetHeaderStyle("120px"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "fullname",
      text: "ชื่อ-สกุล",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      filter: textFilter(customTextFilter),
      style: commonNonBorder,
    },
    {
      dataField: "nickname",
      text: "ชื่อเ่ล่น",
      sort: true,
      style: commonNonBorder,
      headerStyle: () => GetHeaderStyle("120px"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "brchname",
      text: "สาขา",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      filter: textFilter(customTextFilter),
      style: commonNonBorder,
    },
    {
      dataField: "stafftypename",
      text: "ประเภท",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      filter: textFilter(customTextFilter),
      style: commonNonBorder,
    },
    {
      dataField: "ed1",
      text: "",
      headerStyle: () => GetHeaderStyle("105px"),
      formatter: formatEditBox,
      align: "center",
    },
  ];
  //----------------------------------------------------------------------
  return (
    <>
      <div className="table-box-wrapper">
        <div className="table-caption-box">
          <OverlayTrigger
            placement="top"
            overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
          >
            <Button variant="primary" onClick={popupNew}>
              <AiOutlinePlus /> เพิ่มข้อมูลใหม่
            </Button>
          </OverlayTrigger>
          <div className="table-caption-box-right-flex">{props.formName}</div>
          <SerachBox
            onButtonClick={() => {
              setUpdateFlag(true);
            }}
          />
        </div>

        <BoostrapTable
          bootstrap4
          keyField={props.filedIdName}
          rowClasses={"table-next-rows-style"}
          data={data}
          columns={columns}
          striped
          hover
          condensed
          // tabIndexCell
          headerWrapperClasses="headerWrapper"
          wrapperClasses="bs-table-wrapper"
          bordered={true}
          pagination={paginationFactory(<PageOptions />)}
          filter={filterFactory()}
          // rowEvents= {rowEvents}
        />
      </div>
      <StaffPopup
        {...props}
        {...{ capture, setCapture, staffImage, setStaffImage }}
      />
      <MyModalDialog
        confirm={confirmBox}
        setConfirm={setConfirmBox}
        action={deleteRow}
      />
      <ImageCapture
        {...{
          capture,
          setCapture,
          fields,
          setFields,
          staffImage,
          setStaffImage,
        }}
      />
    </>
  );
}
